<template>
  <div class="divCaculateResultDisplay">
    <div class="Top">
      <p class="title"><span style="color: red">*</span> 流程名称:</p>
      <div class="input">
        <el-input size="small" v-model="workflowName" placeholder="请输入"></el-input>
      </div>
    </div>
    <div class="Top">
      <p class="title">备注:</p>
      <div class="input">
        <el-input size="small" v-model="remark" placeholder="请输入"></el-input>
      </div>
    </div>
    <!-- <el-button type="primary" plain @click="addRow">添加行</el-button> -->
    <div class="divNotAllowCaculateResult">
      <el-table
        border
        :data="tableData"
        class="tb-edit"
        style="width: 100%"
        @cell-click="getCell"
        :cell-class-name="tableCellClassName"
        highlight-current-row
      >
        <el-table-column
          fixed
          align="center"
          prop="num"
          label="顺序"
          width="150"
          type="index"
        >
        </el-table-column>
        <el-table-column prop="junctionName" label="节点名称" width="" align="center">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.junctionName"
              @blur="handleBlur(scope.row)"
              v-if="
                scope.row.index == tabRowIndex && scope.column.index == tabColumnIndex
              "
              v-focus
            ></el-input>
            <div v-else>
              <span>{{ scope.row.junctionName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="scheduleProportion" label="进度" width="" align="center">
          <template slot-scope="scope">
            <el-input-number
              size="small"
              v-focus
              v-model="scope.row.scheduleProportion"
              v-if="
                scope.row.index == tabRowIndex && scope.column.index == tabColumnIndex
              "
              @change="handleBlur(scope.row)"
            ></el-input-number>
            <div v-else>
              <span>{{ scope.row.scheduleProportion }}</span>
            </div>
          </template>
        </el-table-column>
        <!-- 此处省略 -->
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="danger" plain @click="handleDelete(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="addtable"><p class="tian" @click="addRow()">添加</p></div>
    </div>
    <el-button type="primary" @click="onsave()">保存</el-button>
  </div>
</template>
<script>
export default {
  directives: {
    //注册一个局部的自定义指令 v-focus，输入框自动聚焦
    focus: {
      inserted: function (el) {
        el.querySelector("input").focus();
      },
    },
  },
  data() {
    return {
      page: 1,
      tabRowIndex: null, //行角标
      tabColumnIndex: "", //列角标
      remark: "",
      workflowName: "",
      tableData: [],
      action: "",
      id: Number(""),
      deleteIdS: [],
    };
  },
  created() {
    let query = this.$route.query;
    this.action = query.action;
    if (query.action === "edit") {
      if (query.kv) {
        this.id = query.kv;
        this.initData(query.kv);
      }
    }
  },
  methods: {
    async initData(id) {
      if (id) {
        let res = await $utils.api.load(`/admin/system/schedule/${id}`);
        try {
          if (res) {
            let list = res.data.sysProjectScheduleStateList || [];
            this.workflowName = res.data.workflowName;
            this.remark = res.data.remark;
            this.tableData = list;
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
    addRow() {
      const hasFullProgress = this.tableData.some(
        (item) => item.scheduleProportion === 100
      );
      if (hasFullProgress) {
        $utils.toast.success("进度已到100%,请勿添加!");
        return;
      }
      this.tableData.push({
        junctionName: "请填写",
        scheduleProportion: 100,
      });
    },
    getCell(row, column, cell, event) {
      this.tabRowIndex = row.index;
      this.tabColumnIndex = column.index;
    },
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      //注意这里是解构
      //利用单元格的 className 的回调方法，给行列索引赋值
      row.index = rowIndex;
      column.index = columnIndex;
    },
    handleBlur(row) {
      this.tabRowIndex = null;
      this.tabColumnIndex = null;
    },
    handleDelete(index, row) {
      this.deleteIdS.push(row.id);
      const indexToRemove = index;
      if (indexToRemove > -1) {
        this.tableData.splice(indexToRemove, 1);
      }
    },
    async onsave() {
      if (this.workflowName == "") {
        $utils.toast.success("请填写流程名称!");
        return;
      }
      if (this.tableData.length == 0) {
        $utils.toast.success("请填写节点数据!");
        return;
      }
      const lastRow = this.tableData[this.tableData.length - 1];
      if (lastRow && lastRow.scheduleProportion !== 100) {
        $utils.toast.success("最后一个进度必须为100%, 请检查!");
        return;
      }
      let d = {
        workflowName: this.workflowName,
        remark: this.remark,
        sysProjectScheduleStateList: this.tableData,
      };
      if (this.action == "edit") {
        d.id = this.id;
        d.deleteIdS = this.deleteIdS;
      }
      let res = await $utils.api.load(
        `/admin/system/schedule`,
        d,
        this.action == "edit" ? "PUT" : "POST"
      );
      if (res.code == 200) {
        $utils.toast.success("保存成功!");
        $utils.url.go(-1);
      }
    },
  },
};
</script>
<style scoped>
.addtable {
  width: 100%;
  border: 1px solid #ebeef5;
  border-top: none;
  text-align: center;
  color: #2d41ef;
}
.tian {
  line-height: 40px;
  cursor: pointer;
}
.divNotAllowCaculateResult {
  margin: 10px 0;
}
.Top {
  display: flex;
  margin: 5px 0;
}
.title {
  font-weight: normal;
  width: 7%;
  margin-right: 10px;
  font-size: 14px;
  line-height: 2.5;
}
.input {
  width: 30%;
}
</style>
